import { render } from "./NewProject.vue?vue&type=template&id=f7532ac0"
import script from "./NewProject.vue?vue&type=script&lang=js"
export * from "./NewProject.vue?vue&type=script&lang=js"

import "./NewProject.vue?vue&type=style&index=0&id=f7532ac0&lang=css"
script.render = render

export default script